import React, {useEffect} from 'react';
import {Link, Route, Switch} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {StoreState} from "../store/StoreState";
import {Actions} from "../store/Actions";
import {ServerApi} from "../ServerApi";
import {MainPage} from "../pages/MainPage";
import {IndexWordListComponent} from "./IndexWordListComponent";
import {WordEditorComponent} from "./WordEditorComponent";
import {DictionaryManagerComponent} from "./DictionaryManagerComponent";
import {UserManagerComponent} from "./UserManagerComponent";
import {PrintListComponent} from './PrintListComponent';
import {ImportExportComponent} from "./ImportExportComponent";
import {SearchResultPage} from "../pages/SearchResultPage";
import {WordDetailPage} from '../pages/WordDetailPage';
import {ReplaceComponent} from "./ReplaceComponent";
import "./App.scss";



// 비밀번호 변경
// 비밀번호 찾기
// 대량 가입 방지
// 사용자 검색

// 이미지 업로드 변경
// 내보내기 갯수 안맞음
// 일괄 수정
// 익스는 다른 브라우저 설치 안내
// 1글자 검색
// 인쇄
// 용어인쇄 사전명
// 사전 삭제시 DB 타이밍 에러
// 엑셀 임포트/익스포트
// 사전 관리 단어 갯수 표시
// 특정 단어를 클릭하면 사전 데이터에 있는 의미를 보이게
// 사용자 관리 다듬기
// 시작함/포함함 검색 (제목에 대해서만 적용됨)
// 글에 사전 정보 표시
// 인덱스 스크롤 버그
// 글에 작성자, 날짜 표시
// 검색 로딩 표시
// 최근 용어 표시 최적화
// 검색결과 없음
export default function App() {
	const dispatch = useDispatch();


	const user = useSelector((state: StoreState) => state.authInfo);


	useEffect(() => {
		ServerApi
			.getAuthInfo()
			.then(user => dispatch(Actions.setAuthInfoAction(user)));
	}, []);


	return (
		<>
			<Switch>
				<Route path="/Words/Update/:wordIdParam(\d+)"><IndexWordListComponent/></Route>
				<Route path="/:wordIdParam(\d+)"><IndexWordListComponent/></Route>
				<Route path="/"><IndexWordListComponent/></Route>
			</Switch>


			<div className="box-wrapper">
				<div className="box">
					<header>
						<nav>
							<ul>
								<li><Link to="/">용어검색</Link></li>

								{(user?.role === "Admin" || user?.role === "Manager") && <li><Link to="/Words/Add">용어추가</Link></li>}

								<li><Link to="/PrintList">용어인쇄</Link></li>

								{user?.role === "Admin" &&
                                <>
                                    <li><Link to="/Replace">일괄수정</Link></li>
                                    <li><Link to="/DictionaryManage">사전관리</Link></li>
                                    <li><Link to="/ImportExport">가져오기/내보내기</Link></li>
                                    <li><Link to="/UserManage">사용자관리</Link></li>
                                </>}

								<div style={{float: "right"}}>
									{user ?
										<>
											<form action="/Identity/Account/Logout?returnUrl=/" method="post">
												<li>
													{user.role === "Admin" ? <></> : <span style={{fontSize: "12px"}}>[{user?.name}]</span>}
													<button type="submit" style={{backgroundColor: "transparent", border: "none", cursor: "pointer"}}>로그아웃</button>
												</li>
											</form>
										</>
										:
										<>
											<li><a href="/Identity/Account/Register">회원가입</a></li>
											<li><a href="/Identity/Account/Login">로그인</a></li>
										</>
									}
								</div>
							</ul>
						</nav>
					</header>


					<main>
						<Switch>
							<Route exact path="/"><MainPage/></Route>
							<Route exact path="/Search"><SearchResultPage/></Route>
							<Route exact path="/PrintList"><PrintListComponent/></Route>
							<Route exact path="/UserManage"><UserManagerComponent/></Route>
							<Route exact path="/Replace"><ReplaceComponent/></Route>
							<Route exact path="/DictionaryManage"><DictionaryManagerComponent/></Route>
							<Route exact path="/ImportExport"><ImportExportComponent/></Route>
							<Route exact path="/Words/Add"><WordEditorComponent/></Route>
							<Route exact path="/Words/Update/:wordIdParam(\d+)"><WordEditorComponent/></Route>
							<Route exact path="/:wordIdParam(\d+)?"><WordDetailPage/></Route>
							<Route><h1>페이지가 존재하지 않습니다.</h1></Route>
						</Switch>
					</main>


					<footer>
						<span>운영자에게 문의하기 : </span><a href="mailto:twainnnn@live.co.kr">twainnnn@live.co.kr</a>
						<br/>
						<span>사전 후원하기 : KEB 하나은행 119-891609-34307</span>
					</footer>
				</div>
			</div>
		</>
	)
}